export function shortenText(stringToSlice: string | undefined, maxChars: number) {
    if(stringToSlice){
        if(stringToSlice.length > maxChars){
            return stringToSlice.slice(0, maxChars - 4) + '...';
        }
        else return stringToSlice;
    }
    else return undefined;
}